export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  });
};

export const getNightDayDuration = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const diffTime = endDate - startDate;
  const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include end date
  const nights = totalDays - 1;

  return `${nights} Night${nights > 1 ? 's' : ''} , ${totalDays} Day${totalDays > 1 ? 's' : ''}`;
};

export const formatDateMonthYear = (timestamp) => {
  if (!timestamp) return ""; // Handle invalid or empty timestamps

  const ts = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;
  const date = new Date(ts);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
};

export const todayIST = new Date().toLocaleDateString('en-CA', {
  timeZone: 'Asia/Kolkata'  // IST
});
//Example "May 24, 2025 at 5:42 PM"
export const getFormattedDateTime = () => {
  const now = new Date();

  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const timeOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const datePart = now.toLocaleDateString("en-US", dateOptions);
  const timePart = now.toLocaleTimeString("en-US", timeOptions);

  return `${datePart} at ${timePart}`;
}




export const validateFile = (file) => {
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  const maxSize = 250 * 1024; // 250KB

  if (!file) return "No file selected";
  if (!allowedTypes.includes(file.type)) return "Only JPG, JPEG, PNG allowed";
  if (file.size > maxSize) return "File size must be under 250KB";
  return null;
};

